import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  makeStyles, Paper, Grid, Button, Box, Typography, ButtonBase, IconButton, Modal,
} from '@material-ui/core';
import CachedIcon from '@material-ui/icons/Cached';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import DirectionsRunIcon from '@material-ui/icons/DirectionsRun';
import LinearProgress from "@material-ui/core/LinearProgress";
import { styled } from "@material-ui/styles";

import {
  formatPosition, formatDate
} from '../common/formatter';
import RemoveDialog from '../RemoveDialog';
import { getIsAdmin, getPosition } from '../common/selectors';
import { useTranslation } from '../LocalizationProvider';
import moment from 'moment';
import { api_call, console_log, empty, getDistanceWithUnit, getLocalTimezone, getSpeedWithUnit, isGpsMT2VProtocolDevice, isIphoneDevice, is_null, updatePageQuery } from '../helpers/untils';
import CreditLogsModal from '../settings/CreditLogsModal';
import { devicesActions, layoutActions } from '../store';
import NotificationModal from '../settings/NotificationModal';
import TollSettingModal from '../settings/TollSettingModal';
import ChargingHistoryModal from '../settings/ChargingHistoryModal';
import MaintSettingModal from '../settings/MaintSettingModal';
import { getFirstWordFromString, setSettingPersist, sleep } from '../helpers/misc';
import CommandSendDialog from './CommandSendDialog';
import { DEVICE_TYPE, DEVICE_USAGE_TYPE, MACHINE_ENVIRONMENT, MOVING_SPEED_MIN, MT2V_DC_VOLT_MAX, SHARE_ACCESS_TYPE } from '../config/constant';
import { linearProgressClasses, Stack } from '@mui/material';
import IncomeExpenseModal from '../settings/modals/IncomeExpenseModal';
import FuelCalibrateModal from '../settings/FuelCalibrateModal';
import CommandSendDialogWrapper from './CommandSendDialogWrapper';
import GoogleGeolocationAddressBox from '../components/GoogleGeolocationAddressBox';
import DeviceSignalBox from '../components/DeviceSignalBox';
import ShareAccessModal from '../settings/ShareAccessModal';
import UserMaintModal from '../settings/UserMaintModal';
import StatusDateMessageModal from '../settings/StatusDateMessageModal';

var user;

const useStyles = makeStyles((theme) => ({
  paper: {
    width: '300px',
    maxWidth: '100%'
  },
  ...theme.palette.colors,
  listItemContainer: {
    // maxWidth: '280px',
    '& .MuiListItem-root': {
      paddingTop: '4px',
      paddingBottom: '4px',
    }
  },
  creditValue: {
    cursor: 'pointer',
    padding: '2px 4px',
    backgroundColor: 'rgba(76, 175, 80, 0.12)',
    border: '2px solid #4CAF50',
    flex: '0 0 auto'
  },
  modalBottomButton: {
    minWidth: '40px'
  },
  modalBottomControlButton: {
    width: '100%',
    flex: 1,
    background: 'rgba(76, 175, 80, 0.01)',
    border: '2px solid rgba(76, 175, 80, 1)',
  },
  lineItem: {
    paddingLeft: '16px',
    paddingRight: '16px',
    paddingTop: '4px',
    paddingBottom: '4px',
    width: '100%'
  },
  itemLabel: {
    width: '105px'
  },
  gridLineList: {
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    width: '100%',
    height: '100%',
    border: '1px solid rgba(0, 0, 0, 0.5)',
    borderRadius: '5px'
  },
  gridLineItem: {
    flex: 1,
    height: '20px',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    // backgroundColor: 'red'
  },
  gridVerticalLine: {
    height: '20px',
    width: '1px',
    backgroundColor: 'rgba(0, 0, 0, 0.5)'
  },
  dateOld: {
    background: 'rgba(255, 0, 0, 0.64)',
    padding: '3px 6px',
    color: '#ffffff',
    borderRadius: '3px'
  },
  dateRecent: {
    // background: 'rgba(255, 0, 0, 0)',
    padding: '3px 6px',
    // color: '#000000',
    borderRadius: '3px'
  },
}));

const BorderLinearProgress = styled(LinearProgress)(({ theme, type, width, bgColor, barColor }) => ({
  height: 20,
  width: width ?? 120,
  borderRadius: 5,
  [`&.${linearProgressClasses.colorPrimary}`]: {
    backgroundColor: bgColor,
  },
  [`& .${linearProgressClasses.barColorPrimary}`]: {
    backgroundColor: barColor
  },
}));

const GasGridLines = () => {
  const classes = useStyles();
  const lineArr = [0, 1, 2, 3, 4, 5, 6, 7]
  return (
    <>
      <div className={classes.gridLineList}>
        {
          lineArr.map((item, index) => {
            return (
              <div key={index} className={classes.gridLineItem}>
                {
                  (index === 3) ? (
                    <div className={classes.gridVerticalLine} style={{ height: '26px' }}></div>
                  ) : (index < 7) ? (
                    <div className={classes.gridVerticalLine}></div>
                  ) : (
                    <></>
                  )
                }
              </div>
            )
          })
        }
      </div>
    </>
  )
}

const GasLineBar = (props) => {
  const classes = useStyles();

  return (
    <>
      <div style={{ display: 'block', width: '100%', position: 'relative', width: '120px', height: '20px' }}>
        <div style={{ display: 'block', position: 'absolute', left: 0, right: 0, top: 0, bottom: 0 }}>
          {
            props.children
          }
        </div>
        <div style={{ display: 'block', position: 'absolute', left: 0, right: 0, top: 0, bottom: 0 }}>
          <GasGridLines />
        </div>
      </div>
    </>
  )
}

const StatusView = ({
  deviceId, onShowDetails, onShowHistory, history, location, onEditClick, lat, lng, onLogClick, onClosePopup, userDeviceItem
}) => {
  const dispatch = useDispatch();
  // const history = useHistory();
  const classes = useStyles();
  const t = useTranslation();

  const [removeDialogShown, setRemoveDialogShown] = useState(false);
  const device = useSelector((state) => state.devices.items[deviceId]);
  useEffect(async () => {
    let devId = localStorage.getItem("deviceId");
    let fromMobile = localStorage.getItem("fromMobile");
    let page = localStorage.getItem("page");
    console.log(`device && devId && page:::`, device, devId, page);
    if (device && devId && page) {
      switch (page) {
        case "share":
          onClickShare(true);
          break;
        case "control":
          handleSendCommand();
          break;
        case "notify":
          showNotificationModal(device);
          break;
        case "toll-chooser":
          showTollChooser(device);
          break;
        case "toll":
          showTollSettingModal(device);
          break;
        case "charging-history":
          showChargingHistoryModal(device);
          break;
        case "maint":
          showMaintSettingModal(device);
          break;
        case "pl":
          onClickPL(device);
          break;
        default:
          break;
      }
    }

    if (!page) {
      dispatch(layoutActions.closeAllAppModal());
    }

    //updatePageQuery({ deviceId: deviceId });
  }, [deviceId])

  //////////////////////// app modal close feature //////////////////////////////////////////
  // const appModalCloseTimestamp = useSelector((state) => state.layout.appModalCloseTimestamp);
  // useEffect(() => {
  //   //console.log("status view::: changes")
  //   dispatch(layoutActions.closeAllAppModal());
  // }, [deviceId]);
  ///////////////////////////////////////////////////////////////////////////////////////////

  useEffect(() => {
    getDeviceStatusViewButtons()
  }, [deviceId])

  const defaultStatusViewButtons = {
    statusViewBottomCommandList: [],
    showReauthButton: false
  }
  const [statusViewButtons, setStatusViewButtons] = useState(defaultStatusViewButtons)
  const getDeviceStatusViewButtons = async () => {
    if (deviceId) {
      const response = await api_call(`/api/device-status-view-buttons/${deviceId}`);
      if (response.ok) {
        const data = await response.json()
        setStatusViewButtons(data)
      } else {
        setStatusViewButtons(defaultStatusViewButtons)
      }
    }
  }

  const position = useSelector(getPosition(deviceId));

  //console_log("StatusView::::::", userDeviceItem);

  user = useSelector((state) => state.session.user);

  const isAdmin = useSelector(getIsAdmin);

  const handleClick = (e) => {
    e.preventDefault();
    onShowDetails(position.id);
  };

  const handleEditClick = (e) => {
    e.preventDefault();
    onEditClick(deviceId);
  };

  const handleRemove = () => {
    setRemoveDialogShown(true);
  };

  const handleRemoveResult = () => {
    setRemoveDialogShown(false);
    onClosePopup(deviceId)
  };

  const handleLog = async (e) => {
    e.preventDefault();

    dispatch(devicesActions.setSelectedDeviceName(device.name));
    dispatch(devicesActions.setSelectedDeviceId(device.id));
    await sleep(20)

    onLogClick(deviceId);
  };

  const [open, setOpen] = useState(false);
  const [selectedValue, setSelectedValue] = useState("");
  const [commandsDetail, setCommandsDetail] = useState();
  const [coHostDeviceDetail, setCoHostDeviceDetail] = useState(null);

  const handleSendCommand = async () => {
    var url = `/api/userDeviceCommandsDetail/${deviceId}`;
    const response = await api_call(url);
    if (response.ok) {
      const apiRes = await response.json()
      setCommandsDetail(apiRes.commands);
      setCoHostDeviceDetail(apiRes.coHostDeviceRow)
    }
    setOpen(true);
  }

  const handleClose = (value) => {
    setOpen(false);
    setSelectedValue(value);
  }

  ////////////////////////////////credit log modal////////////////////////////////
  const [deviceItem, setDeviceItem] = useState({});
  const showCreditLogsPage = (item) => {
    setDeviceItem(item);
    setCreditModalOpen(true)
  }

  ///////////////////////////////////////////////////////////
  const [creditModalOpen, setCreditModalOpen] = useState(false);

  let sendingSingal = false;
  const onClickSingal = async () => {
    if (device.deviceType !== DEVICE_TYPE.MOOVETRAX) {
      return false
    }
    if (sendingSingal) {
      return false;
    }
    sendingSingal = true;
    console_log("onClickSingal::::");
    let value = "Iccid"
    let response = await api_call(`/api/command?command=${value}&deviceId=${device.id}&userId=${user.id}`);
    if (response.ok) {
      console_log("Sent Iccid Command.");
    }
    value = "Rssid"
    response = await api_call(`/api/command?command=${value}&deviceId=${device.id}&userId=${user.id}`);
    if (response.ok) {
      console_log("Sent Rssid Command.");
    }
    sendingSingal = false;
  }

  //////////////////////// share access modal ///////////////////////////////////
  const [shareAccessModalOpen, setShareAccessModalOpen] = useState(false);

  const sendShareRef = useRef(false)
  const onClickShare = async (callFromUrl) => {
    if (sendShareRef.current) {
      console_log(`sendShareRef is already sending....`)
      return false
    }
    sendShareRef.current = true

    // Delivery devices only share a temporary location link, so skip the access
    // type check and go straight to the shared url (delivery) page.
    if (device?.usage_type === DEVICE_USAGE_TYPE.DELIVERY) {
      sendShareRef.current = false
      if (!callFromUrl) {
        history.push(`/share/${device.id}`)
      }
      return false
    }

    let response = await api_call(`/api/device-share/check-share-access-type/${device.id}`);
    sendShareRef.current = false
    if (response.ok) {
      const responseObj = await response.json();
      const shareAccessType = responseObj['shareAccessType']
      console.log(`shareAccessType::::`, shareAccessType)
      if (shareAccessType === SHARE_ACCESS_TYPE.RESERVATION_ID) {
        setShareAccessModalOpen(true)
      } else {
        if (!callFromUrl) {
          history.push(`/share/${device.id}`)
        }
      }
    }
  }
  ///////////////////////////////////////////////////////////////////////////////////////////


  ////////////////////////////////notification modal////////////////////////////////
  const showNotificationModal = (item) => {
    setDeviceItem(item);
    setNotificationModalOpen(true);
  }
  const [notificationModalOpen, setNotificationModalOpen] = useState(false);
  ////////////////////////////////end notification modal////////////////////////////

  ////////////////////////////////toll / charging chooser////////////////////////////////
  const showTollChooser = (item) => {
    if (item.deviceType === DEVICE_TYPE.TESLA) {
      updatePageQuery(location.search, { page: "toll-chooser", deviceId: item.id });

      setDeviceItem(item);
      setTollChooserOpen(true);
    }
    else {
      showTollSettingModal(item);
    }
  }
  const [tollChooserOpen, setTollChooserOpen] = useState(false);
  const onChooseToll = (item) => {
    setTollChooserOpen(false);
    showTollSettingModal(item);
  }
  const onChooseCharging = (item) => {
    setTollChooserOpen(false);
    showChargingHistoryModal(item);
  }

  const showChargingHistoryModal = (item) => {
    updatePageQuery(location.search, { page: "charging-history", deviceId: item.id });

    setDeviceItem(item);
    setChargingHistoryModalOpen(true);
  }
  ////////////////////////////////end toll / charging chooser////////////////////////////

  ////////////////////////////////toll setting modal////////////////////////////////
  const showTollSettingModal = (item) => {
    updatePageQuery(location.search, { page: "toll", deviceId: item.id });

    setDeviceItem(item);
    setTollSettingModalOpen(true)
  }
  const [tollSettingModalOpen, setTollSettingModalOpen] = useState(false);
  ////////////////////////////////end toll setting modal////////////////////////////

  ////////////////////////////////charging history modal////////////////////////////////
  const [chargingHistoryModalOpen, setChargingHistoryModalOpen] = useState(false);
  ////////////////////////////////end charging history modal////////////////////////////

  ////////////////////////////////maint setting modal////////////////////////////////
  const showMaintSettingModal = (item) => {
    setDeviceItem(item);
    // if (MACHINE_ENVIRONMENT === "dev" || MACHINE_ENVIRONMENT === "testLiveDB") {
    //   setUserMaintModalOpen(true);
    // } else {
    //   setMaintSettingModalOpen(true);
    // }
    setUserMaintModalOpen(true);
  }

  const showDeviceMaintSettingModal = () => {
    setUserMaintModalOpen(false);
    setMaintSettingModalOpen(true);
  }

  const [maintSettingModalOpen, setMaintSettingModalOpen] = useState(false);
  const [userMaintModalOpen, setUserMaintModalOpen] = useState(false);
  ////////////////////////////////end maint setting modal////////////////////////////

  const [fuelCalibrateModalOpen, setFuelCalibrateModalOpen] = useState(false);

  //////////////////////////////////////////////////////////////////////////////////
  const defaultSignalText = "Signal"
  const [signalText, setSignalText] = useState(defaultSignalText);

  const checkEmnifyConnectivity = async () => {
    const url = '/api/devices/check-emnify-connectivity'
    const data = { device_id: deviceId }
    const response = await api_call(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    if (response.ok) {
      const resData = await response.json();
      if (resData['error']) {
        // 
      } else {
        const operatorName = resData['operatorName']
        setSignalText(operatorName)
        return true
      }
    }
    setSignalText(defaultSignalText)
  }

  useEffect(() => {
    checkEmnifyConnectivity()
  }, [deviceId])

  const [commandCalling, setCommandCalling] = useState({});
  const onClickCommandButton = async (value, deviceId) => {
    if (commandCalling[value]) {
      return false
    }

    const callingStatus = {}
    callingStatus[value] = true
    setCommandCalling({ ...commandCalling, ...callingStatus })
    const response = await api_call(`/api/command?command=${value}&deviceId=${deviceId}&userId=${user.id}`);
    if (response.ok) {
      console.log("Sent Command.");
    }
    callingStatus[value] = false
    setCommandCalling({ ...commandCalling, ...callingStatus })
  }

  ///////////////////// battery function ///////////////////////////////////////
  const getDeviceBatteryLevel = (crop = false) => {
    let level = 0
    if (device && device?.mt2v_dc_volt > 0) {
      level = device?.mt2v_dc_volt
    }
    if (crop) {
      level = Math.min(level, 100)
    }
    level = Math.floor(Number(level))
    return level
  }

  const getBatteryLevelColor = () => {
    let color = "default"
    const level = getDeviceBatteryLevel(true)
    if (level >= 20) {
      color = "green"
    } else {
      color = "red"
    }
    return color
  }

  const getDeviceVoltage = (crop = false) => {
    let volt = 0
    if (device && device?.mt2v_dc_volt > 0) {
      volt = device?.mt2v_dc_volt
    }
    if (crop) {
      volt = Math.min(volt, MT2V_DC_VOLT_MAX)
    }
    return volt
  }
  const getBatteryColor = () => {
    let color = "default"
    const volt = getDeviceVoltage(true)
    if (volt >= 14.4) {
      color = "green"
      return color
    }

    if (volt >= 12.5 && !device.acc) {
      color = "green"
    }
    else if (volt <= 13 && device.acc && device.speed >= MOVING_SPEED_MIN) {
      color = "orange"
    }

    if (volt < 12) {
      color = "red"
    }
    return color
  }

  const getFuelPercent = () => {
    if (!is_null(device.minFuel) && !is_null(device.maxFuel)) {
      const a0 = (1 / 3) * (4 * device.minFuel - device.maxFuel)
      if (device.maxFuel - a0 !== 0) {
        let p = 100 * (device.fuel - a0) / (device.maxFuel - a0)
        if (p < 0) {
          p = 0
        }
        if (p > 100) {
          p = 100
        }
        return p
      }
    }
    return null
  }

  const onClickFuelBar = (item) => {
    setDeviceItem(item);
    setFuelCalibrateModalOpen(true)
  }

  const onClickBatteryLevel = () => {
    if (device.deviceType === DEVICE_TYPE.TESLA) {
      showChargingHistoryModal(device)
    } else {
      return true;
    }
  }

  const onClickChargingPower = () => {
    if (device.deviceType === DEVICE_TYPE.TESLA) {
      showChargingHistoryModal(device)
    } else {
      return true;
    }
  }

  const renderBatteryGasBar = () => {
    const batteryLevelInfo = position?.batteryLevelInfo || userDeviceItem?.batteryLevelInfo;
    const gasLevelInfo = position?.gasLevelInfo || userDeviceItem?.gasLevelInfo;
    return (
      <>
        <Stack direction={`column`} spacing={1} sx={{ width: '100%', pt: 1 }}>
          {
            (batteryLevelInfo) ? (
              <>
                <Stack className={classes.lineItem} direction={`row`} justifyContent={`space-between`} alignItems={`center`} spacing={1}>
                  <Box sx={{ flex: 1 }}>
                    <Stack className={classes.itemLabel} direction={`row`} justifyContent={`space-between`} alignItems={`center`} spacing={0}>
                      <Typography variant="body1">
                        {batteryLevelInfo.batteryLabel}:
                      </Typography>
                      <Typography variant="body1">
                        <span style={{ fontSize: '0.9em' }}>{batteryLevelInfo.batteryLevelStr}</span>
                      </Typography>
                    </Stack>
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <Stack direction={`row`} justifyContent={`flex-start`} alignItems={`center`} spacing={0.5} sx={{ width: '100%' }}>
                      <ButtonBase disableRipple={true} onClick={() => onClickBatteryLevel()}>
                        <BorderLinearProgress
                          variant="determinate"
                          //type={batteryLevelInfo.batteryLevelColor}
                          bgColor={batteryLevelInfo.batteryLevelBgColor}
                          barColor={batteryLevelInfo.batteryLevelBarColor}
                          value={batteryLevelInfo.batteryLevelValue}
                          width={batteryLevelInfo.showBattryRunIcon ? 100 : null}
                        />
                      </ButtonBase>
                      {
                        (batteryLevelInfo.showBattryRunIcon) ? (
                          <><DirectionsRunIcon /></>
                        ) : (<></>)
                      }
                    </Stack>
                  </Box>
                </Stack>
              </>
            ) : (
              <>
              </>
            )
          }

          {
            (gasLevelInfo) ? (
              <>
                <Stack className={classes.lineItem} direction={`row`} justifyContent={`space-between`} alignItems={`center`} spacing={1}>
                  <Box sx={{ flex: 1 }}>
                    <Stack className={classes.itemLabel} direction={`row`} justifyContent={`space-between`} alignItems={`center`} spacing={0}>
                      <Typography variant="body1">
                        {gasLevelInfo.gasLabel}:
                      </Typography>
                      <Typography variant="body1">
                        <span style={{ fontSize: '0.9em' }}>{gasLevelInfo.gasLevelStr}</span>
                      </Typography>
                    </Stack>
                  </Box>
                  <Box sx={{ flex: 1 }}>
                    <ButtonBase disableRipple={true} onClick={() => onClickFuelBar(device)}>
                      <GasLineBar>
                        <BorderLinearProgress
                          variant="determinate"
                          //type={gasLevelInfo.gasLevelColor}
                          bgColor={gasLevelInfo.gasLevelBgColor}
                          barColor={gasLevelInfo.gasLevelBarColor}
                          value={gasLevelInfo.gasLevelValue}
                        />
                      </GasLineBar>
                    </ButtonBase>
                  </Box>
                </Stack>
              </>
            ) : (
              <></>
            )
          }
        </Stack>
      </>
    )
  }

  const [incomeExpenseModalOpen, setIncomeExpenseModalOpen] = useState(false);
  const onClickPL = (item) => {
    setDeviceItem(item);
    setIncomeExpenseModalOpen(true)
  }

  const onClickReauthDevice = async () => {
    const response = await api_call(`/api/smartcar/get-login-url`);
    if (response.ok) {
      const res = await response.json()
      console_log("smartcar res:::", res)
      setSettingPersist('smartcar_auth_source', 'device')
      window.location.href = res.link
      //history.push('/smartcar-device')
    } else {
      alert("Smartcar authentication error")
    }
  }

  const onClickNav = () => {
    let url = `https://www.google.com/maps/dir/your+location/${position.latitude},${position.longitude}/@${position.latitude},${position.longitude},17z`
    const isIphone = isIphoneDevice();
    console.log(`isIphone::::`, isIphone);
    if (isIphone) {
      // url = `https://maps.apple.com/?q=${position.latitude},${position.longitude}`
      url = `https://maps.apple.com/?daddr=${position.latitude},${position.longitude}`
    }
    console.log(`map url::::`, url);
    window.open(url, '_blank');
  }

  const [statusDateMessageModalOpen, setStatusDateMessageModalOpen] = useState(false);
  const [statusDateMessage, setStatusDateMessage] = useState("");
  const onClickStatusMessage = async (field) => {
    const iana_timezone = getLocalTimezone();
    const response = await api_call(`/api/device-status/date-message?deviceId=${deviceId}&field=${field}&iana_timezone=${iana_timezone}`);
    if (response.ok) {
      const res = await response.json();
      const message = res?.message;
      if (message) {
        setStatusDateMessage(message);
        setStatusDateMessageModalOpen(true);
      }
    } else {
      alert("Invalid request!");
    }
  }

  return (
    <>
      {
        (userDeviceItem) ? (
          <>
            <div className='status-view-popup' style={{ maxHeight: 'calc(100vh - 185px)', overflowY: 'auto' }}>
              <Paper className={classes.paper} elevation={0} square>
                <Grid container direction="column">
                  <Grid item>
                    <List>
                      <ListItem classes={{ container: classes.listItemContainer }}>
                        <Stack direction={`row`} justifyContent={`space-between`} alignItems={`center`} spacing={1} sx={{ flex: 1, width: '100%' }}>
                          <ListItemText primary={<div style={{ maxWidth: '200px', wordBreak: 'break-word' }}>
                            {userDeviceItem.name}
                          </div>} />
                          <Stack direction={`row`} justifyContent={`flex-start`} alignItems={`center`} spacing={1}>
                            {
                              (statusViewButtons['showReauthButton']) ? (
                                <>
                                  <IconButton size={`small`} type="button" title="Reauthenticate" onClick={() => onClickReauthDevice()}>
                                    <CachedIcon />
                                  </IconButton>
                                </>
                              ) : (
                                <></>
                              )
                            }
                            <span className={classes.creditValue} title={`Click here to show credit logs or make paypal subscription`} onClick={() => { showCreditLogsPage(device) }}>$ {device.credit}</span>
                          </Stack>
                        </Stack>
                      </ListItem>
                      {
                        ([DEVICE_TYPE.MOOVETRAX, DEVICE_TYPE.USB, DEVICE_TYPE.OBD, DEVICE_TYPE.KILLSWITCH, DEVICE_TYPE.RLKS, DEVICE_TYPE.KS2G, DEVICE_TYPE.OTHER].includes(device.deviceType)) ? (
                          <>
                            <ListItem classes={{ container: classes.listItemContainer }}>
                              <ListItemText primary={signalText} />
                              <DeviceSignalBox
                                viewLocation="StatusView"
                                device={device}
                                callbackOnClickSingal={() => onClickSingal()}
                                onClickWeakIndicator={() => onClickStatusMessage('signal')}
                              />
                            </ListItem>
                          </>
                        ) : (
                          <></>
                        )
                      }

                      {
                        (position.ac_charging_power > 0 || position.dc_charging_power > 0) ? (
                          <>
                            <ListItem classes={{ container: classes.listItemContainer }}>
                              <ListItemText primary="Charging" />
                              <ListItemSecondaryAction>
                                <ButtonBase disableRipple={true} onClick={() => onClickChargingPower()}>
                                  <span className={classes.charingText}>{Math.max(position.ac_charging_power, position.dc_charging_power)} Kw</span>
                                </ButtonBase>
                              </ListItemSecondaryAction>
                            </ListItem>
                          </>
                        ) : (
                          <></>
                        )
                      }

                      <ListItem classes={{ container: classes.listItemContainer }}>
                        {/* <ListItemText primary={<a href={TESLA_PERMISSION_URL} target='_blank' style={{ color: 'rgba(0, 0, 0, 0.87)' }}>Position</a>} /> */}
                        <ListItemText primary="Position" />
                        <ListItemSecondaryAction>
                          {
                            (device.lastPosition && moment(device.lastConnect).diff(moment(device.lastPosition), "seconds") > 5 * 60 * 60) ? (
                              <>
                                <ButtonBase onClick={() => onClickStatusMessage('lastPosition')} disableRipple={true}>
                                  <span className={classes.dateOld}>{formatDate(device.lastPosition)}</span>
                                </ButtonBase>
                              </>
                            ) : (
                              <>
                                <span className={classes.dateRecent}>{formatDate(device.lastPosition)}</span>
                              </>
                            )
                          }
                        </ListItemSecondaryAction>
                      </ListItem>

                      <ListItem classes={{ container: classes.listItemContainer }}>
                        <ListItemText primary="Connect" />
                        <ListItemSecondaryAction>
                          {
                            (device.lastConnect && moment().diff(moment(device.lastConnect), "seconds") > 60 * 60) ? (
                              <>
                                <ButtonBase onClick={() => onClickStatusMessage('lastConnect')} disableRipple={true}>
                                  <span className={classes.dateOld}>{formatDate(device.lastConnect)}</span>
                                </ButtonBase>
                              </>
                            ) : (
                              <>
                                <span className={classes.dateRecent}>{formatDate(device.lastConnect)}</span>
                              </>
                            )
                          }
                        </ListItemSecondaryAction>
                      </ListItem>

                      <ListItem classes={{ container: classes.listItemContainer }} style={{ marginTop: '8px' }}>
                        {/* <ListItemText primary="Address" /> */}
                        <ListItemSecondaryAction>
                          <GoogleGeolocationAddressBox
                            lat={position.latitude}
                            lng={position.longitude}
                          />
                        </ListItemSecondaryAction>
                      </ListItem>

                      <ListItem classes={{ container: classes.listItemContainer }}>
                        <ListItemText primary={t('positionSpeed')} />
                        {
                          (device.deviceType === DEVICE_TYPE.SMARTCAR || device.deviceType === DEVICE_TYPE.TESLA) ? (
                            <>
                              <ListItemSecondaryAction>
                                {getSpeedWithUnit(position.speed, device.distance_unit)}
                              </ListItemSecondaryAction>
                            </>
                          ) : (
                            <>
                              {
                                (moment().diff(moment(device.lastPosition), "seconds") < 5 * 60 || MACHINE_ENVIRONMENT === 'dev') ? (
                                  <ListItemSecondaryAction>
                                    {getSpeedWithUnit(position.speed, device.distance_unit)}
                                  </ListItemSecondaryAction>
                                ) : (
                                  <ListItemSecondaryAction>
                                    {getSpeedWithUnit(0, device.distance_unit)}
                                  </ListItemSecondaryAction>
                                )
                              }
                            </>
                          )
                        }

                      </ListItem>
                      <ListItem classes={{ container: classes.listItemContainer }}>
                        <ListItemText primary="Odometer" />
                        <ListItemSecondaryAction>
                          {getDistanceWithUnit(position.distance, device.distance_unit)}
                        </ListItemSecondaryAction>
                      </ListItem>
                      <ListItem classes={{ container: classes.listItemContainer }}>
                        <ListItemText primary={t('positionDirection')} />
                        <ListItemSecondaryAction>
                          {formatPosition(position.direction, 'direction', t)}
                        </ListItemSecondaryAction>
                      </ListItem>

                      <>
                        {
                          (userDeviceItem?.measure_type === 'gas') ? (
                            <></>
                          ) : (
                            <>
                              {
                                renderBatteryGasBar()
                              }
                            </>
                          )
                        }
                      </>

                      {/* <div className='hidden d-none temporary-hidden'>
                        <ListItem classes={{ container: classes.listItemContainer }}>
                          <ListItemText primary="Door" />
                          <ListItemSecondaryAction>
                            {device.door ? "Closed" : "Open"}
                          </ListItemSecondaryAction>
                        </ListItem>
                      </div> */}

                      {/* <div className='mt-2'></div> */}
                      <Grid container>
                        {user.id !== 0 &&
                          <Grid item>
                            <Button className={classes.modalBottomButton} color="secondary" onClick={() => { updatePageQuery(location.search, { page: "share", deviceId: deviceId }); onClickShare(); }}>Share</Button>
                          </Grid>}

                        <Grid item>
                          <Button className={classes.modalBottomButton} color="secondary" onClick={() => { updatePageQuery(location.search, { page: "", deviceId: deviceId }); onShowHistory(device.id); }}>Replay</Button>
                        </Grid>
                        <Grid item>
                          <Button className={classes.modalBottomButton} color="secondary" onClick={() => { updatePageQuery(location.search, { page: "control", deviceId: deviceId }); handleSendCommand(); }}>Control</Button>
                        </Grid>
                        <Grid item>
                          <Button className={classes.modalBottomButton} color="secondary" onClick={() => { updatePageQuery(location.search, { page: "notify", deviceId: deviceId }); showNotificationModal(device); }}>Notify</Button>
                        </Grid>
                        <Grid item>
                          <Button className={classes.modalBottomButton} color="secondary" onClick={() => { updatePageQuery(location.search, { page: "", deviceId: deviceId }); onClickNav(); }}>Nav</Button>
                        </Grid>

                        {user.id !== 0 && <>

                          {empty(userDeviceItem?.co_host_device) && <Grid item>
                            <Button className={classes.modalBottomButton} color="secondary" onClick={(e) => { updatePageQuery(location.search, { page: "", deviceId: deviceId }); handleEditClick(e); }}>Edit{device?.co_host_device}</Button>
                          </Grid>}
                          {user.administrator && <Grid item>
                            <Button className={classes.modalBottomButton} color="secondary" onClick={() => { updatePageQuery(location.search, { page: "", deviceId: deviceId }); handleRemove(); }}>Del</Button>
                          </Grid>}
                          <Grid item>
                            <Button className={classes.modalBottomButton} color="secondary" onClick={(e) => { updatePageQuery(location.search, { page: "", deviceId: deviceId }); handleLog(e); }}>Log</Button>
                          </Grid>
                          <Grid item>
                            <Button className={classes.modalBottomButton} color="secondary" onClick={() => { showTollChooser(device) }}>Toll</Button>
                          </Grid>
                          <Grid item>
                            <Button className={classes.modalBottomButton} color="secondary" onClick={() => { updatePageQuery(location.search, { page: "maint", deviceId: deviceId }); showMaintSettingModal(device); }}>Maint</Button>
                          </Grid>
                          {!user.administrator && <Grid item>
                            <Button className={classes.modalBottomButton} color="secondary" onClick={() => { updatePageQuery(location.search, { page: "pl", deviceId: deviceId }); onClickPL(device); }}>P&L</Button>
                          </Grid>}
                        </>}
                      </Grid>

                      {
                        (statusViewButtons['statusViewBottomCommandList'] && statusViewButtons['statusViewBottomCommandList'].length > 0) ? (
                          <Box className="control-box" sx={{ paddingLeft: 8, paddingRight: 8 }}>
                            <Grid container spacing={1}>
                              {
                                statusViewButtons['statusViewBottomCommandList'].map((bottomCommandItem) => {
                                  const bottomCommandName = bottomCommandItem['CommandName']
                                  const bottomCommandLabel = bottomCommandItem['CommandLabel']
                                  return (
                                    <Grid item xs={6} key={bottomCommandName}>
                                      <Button className={classes.modalBottomControlButton} color="secondary" disabled={commandCalling[bottomCommandName]} onClick={() => { onClickCommandButton(bottomCommandName, device.id) }}>{bottomCommandLabel}</Button>
                                    </Grid>
                                  )
                                })
                              }
                            </Grid>
                          </Box>
                        ) : (
                          <></>
                        )
                      }

                      <>
                        {
                          (userDeviceItem?.measure_type !== 'gas') ? (
                            <></>
                          ) : (
                            <>
                              {
                                renderBatteryGasBar()
                              }
                            </>
                          )
                        }
                      </>

                    </List>
                  </Grid>
                </Grid>
              </Paper>
              <RemoveDialog open={removeDialogShown} endpoint="devices" itemId={deviceId} onResult={handleRemoveResult} />

              <>
                <CommandSendDialogWrapper
                  selectedValue={selectedValue}
                  open={open}
                  onClose={handleClose}
                  deviceId={deviceId}
                  commandsDetail={commandsDetail}
                  setCommandsDetail={setCommandsDetail}
                  history={history}
                  coHostDeviceDetail={coHostDeviceDetail}
                  setCoHostDeviceDetail={setCoHostDeviceDetail}
                  device={device}
                  userDeviceItem={userDeviceItem}
                >
                  <>
                    <CommandSendDialog
                      selectedValue={selectedValue}
                      open={open}
                      onClose={handleClose}
                      deviceId={deviceId}
                      commandsDetail={commandsDetail}
                      setCommandsDetail={setCommandsDetail}
                      history={history}
                      coHostDeviceDetail={coHostDeviceDetail}
                      setCoHostDeviceDetail={setCoHostDeviceDetail}
                      device={device}
                      userDeviceItem={userDeviceItem}
                    />
                  </>
                </CommandSendDialogWrapper>
              </>

              <>
                <CreditLogsModal
                  open={creditModalOpen}
                  setOpen={setCreditModalOpen}
                  item={deviceItem}
                  setItem={setDeviceItem}
                />
              </>

              <>
                <NotificationModal
                  open={notificationModalOpen}
                  setOpen={setNotificationModalOpen}
                  deviceItem={deviceItem}
                  setDeviceItem={setDeviceItem}
                />
              </>

              <>
                <TollSettingModal
                  open={tollSettingModalOpen}
                  setOpen={setTollSettingModalOpen}
                  deviceItem={deviceItem}
                  setDeviceItem={setDeviceItem}
                  history={history}
                />
              </>

              <>
                <Modal
                  open={tollChooserOpen}
                  onClose={() => setTollChooserOpen(false)}
                  aria-labelledby="toll-chooser-title"
                >
                  <Box sx={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '90%', maxWidth: '320px', bgcolor: 'background.paper', boxShadow: 24, p: 3 }}>
                    <Typography id="toll-chooser-title" variant="h6" sx={{ mb: 2, textAlign: 'center' }}>What would you like to view?</Typography>
                    <Grid container spacing={1} justifyContent="center">
                      <Grid item xs={6}>
                        <Button fullWidth type="button" color="primary" variant="contained" onClick={() => onChooseToll(device)}>Toll</Button>
                      </Grid>
                      <Grid item xs={6}>
                        <Button fullWidth type="button" color="primary" variant="contained" onClick={() => onChooseCharging(device)}>Charging</Button>
                      </Grid>
                    </Grid>
                  </Box>
                </Modal>
              </>

              <>
                <ChargingHistoryModal
                  open={chargingHistoryModalOpen}
                  setOpen={setChargingHistoryModalOpen}
                  deviceItem={deviceItem}
                  setDeviceItem={setDeviceItem}
                  history={history}
                />
              </>

              <>
                <MaintSettingModal
                  open={maintSettingModalOpen}
                  setOpen={setMaintSettingModalOpen}
                  deviceItem={deviceItem}
                  setDeviceItem={setDeviceItem}
                  history={history}
                  onClickPL={() => onClickPL(device)}
                />
              </>

              <>
                <UserMaintModal
                  open={userMaintModalOpen}
                  setOpen={setUserMaintModalOpen}
                  deviceItem={deviceItem}
                  setDeviceItem={setDeviceItem}
                  history={history}
                  onClickPL={() => onClickPL(device)}
                  showDeviceMaintSettingModal={() => showDeviceMaintSettingModal()}
                />
              </>

              <>
                <IncomeExpenseModal
                  open={incomeExpenseModalOpen}
                  setOpen={setIncomeExpenseModalOpen}
                  deviceItem={deviceItem}
                  setDeviceItem={setDeviceItem}
                  history={history}
                />
              </>

              <>
                <FuelCalibrateModal
                  open={fuelCalibrateModalOpen}
                  setOpen={setFuelCalibrateModalOpen}
                  deviceItem={deviceItem}
                  setDeviceItem={setDeviceItem}
                  history={history}
                />
              </>

              <>
                <ShareAccessModal
                  open={shareAccessModalOpen}
                  setOpen={setShareAccessModalOpen}
                  deviceItem={deviceItem}
                  setDeviceItem={setDeviceItem}
                  deviceId={device.id}
                  history={history}
                />
              </>

              <>
                <StatusDateMessageModal
                  open={statusDateMessageModalOpen}
                  setOpen={setStatusDateMessageModalOpen}
                  deviceId={device.id}
                  message={statusDateMessage}
                  history={history}
                />
              </>

            </div>
          </>) :
          (<></>)
      }
    </>

  );
};

export default StatusView;
